import { useRef } from 'react';

type MarqueeProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

export function Marquee({ children, className, id }: MarqueeProps) {
  const marqueeContainerRef = useRef<HTMLDivElement | null>(null);
  const marqueeRef = useRef<HTMLDivElement | null>(null);

  const handleHover = () => {
    const marqueeContainer = marqueeContainerRef.current;
    const marquee = marqueeRef.current;
    if (marqueeContainer && marquee) {
      const shouldApply = marqueeContainer.scrollWidth > marquee.clientWidth;

      if (shouldApply) {
        const scrollDiff = marqueeContainer.scrollWidth - marquee.clientWidth;
        const transitionDuration = Math.min(scrollDiff / 100, 10);
        marquee.style.transitionDuration = `${transitionDuration}s`;
        marquee.style.marginLeft = `-${marqueeContainer.scrollWidth - marquee.clientWidth + 34}px`;
      }
    }
  };
  const handleMouseLeave = () => {
    const marquee = marqueeRef.current;
    if (marquee) {
      marquee.style.transitionDuration = `1.5s`;
      marquee.style.marginLeft = '0';
    }
  };

  return (
    <div
      ref={marqueeContainerRef}
      className="lg:whitespace-nowrap overflow-hidden cursor-default
       lg:[mask-image:_linear-gradient(to_right,transparent_0,_black_0px,_black_calc(100%-89px),transparent_100%)]"
      onMouseEnter={handleHover}
      onMouseLeave={handleMouseLeave}
    >
      <div className="transition-all ease-linear" ref={marqueeRef}>
        <span className={`pr-9 ${className} tracking-[-0.23px]`}>{children}</span>
      </div>
    </div>
  );
}
